export enum Medical {
    MEDICAL = 'Medical',
    NON_MEDICAL = 'Non-medical'
}